import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { FiInfo } from 'react-icons/fi'
import type { CSSProperties } from 'react'

const descriptionWrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'start',
  columnGap: '4px'
}

const TestConfigFixedEeDescription = () =>
  <div style={descriptionWrapperStyle}>
    <Color variant='theme-description-text'>
      <FiInfo
        aria-hidden
        size={16}
      />
    </Color>
    <Paragraph>
      <strong>
        <Color
          display='inline'
          variant='theme-description-text'
        >
          This execution environment is linked to the SUTs selected. To use a different environment, please update the SUT settings.
        </Color>
      </strong>
    </Paragraph>
  </div>

export default TestConfigFixedEeDescription
